import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { HelpContent } from './help-content.typing';

@RegisterYCState()
export class HelpContentState extends BaseYcState {
  contents: HelpContent[];
}
